<template>
   <common-dialog-form
      title="Edit SST Parameters"
      @close="$emit('close')"
      :visible="visible"
      @submit="$emit('submit', paramsForm)"
      >
      <input-field
         label="Total number of household"
         type="number"
         v-model="paramsForm.hh_per_municipality"
         :errors="[]"
         required
      />
      <input-field
         label="No of household per cluster in urban area"
         type="number"
         v-model="paramsForm.hh_per_cluster_urban"
         :errors="[]"
         required
      />
      <input-field
         label="No of household per cluster in rural area"
         type="number"
         v-model="paramsForm.hh_per_cluster_rural"
         :errors="[]"
         required
      />
      <input-field
         label="Desired cluster size"
         type="select"
         v-model="paramsForm.desired_cluster_size"
         :errors="[]"
         :options="[
            { title: '100mx100m', value: 1 },  
            { title: '200mx200m', value: 2 },  
            { title: '300mx300m', value: 3 },  
            { title: '400mx400m', value: 4 },  
            { title: '500mx500m', value: 5 },  
            { title: '600mx600m', value: 6 },  
            { title: '700mx700m', value: 7 },  
            { title: '800mx800m', value: 8 },  
         ]"
         required
      />
      <atom-button @click="resetParams">Reset Parameters</atom-button>
   </common-dialog-form>
</template>

<script>
import CommonDialogForm from '@/components/organisms/Home/CommonDialogForm';
import InputField from '@/components/molecules/Login/InputField';
import AtomButton from '@/components/atoms/Login/Button';

const requiredParams = [ 
   "hh_per_municipality",
   "hh_per_cluster_urban",
   "hh_per_cluster_rural",
   "desired_cluster_size",
];

export default {
   name: "sst-params-form",
   components: {
      InputField,
      AtomButton,
      CommonDialogForm,
   },
   data()
   {
      return {
         showParamsForm: false,
         paramsForm: this.getDefaultParams(),
      };
   },
   props: {
      parentParams: {
         type: Object,
         required: true,
         validator: params => Object.entries(params).every(([key, value]) => {
            console.log(requiredParams.includes(key), typeof value, key, value);
            return requiredParams.includes(key) && !isNaN(value);
         }),
      },
      visible: {
         type: Boolean,
         required: true,
      }
   },
   watch:
   {
      visible: {
         // everytime form's visible update the paramsForm to match the parent's parameters
         handler: function(newValue) { newValue && this.updateToMatch()},
         immediate: true,
      }
   },
   methods: {
      updateToMatch()
      {
         this.paramsForm = this.parentParams;
      },
      resetParams()
      {
         this.paramsForm = this.getDefaultParams();
      },
      getDefaultParams()
      {
         return {
            hh_per_municipality: 400,
            hh_per_cluster_urban: 10,
            hh_per_cluster_rural: 10,
            desired_cluster_size: 5,
         };
      },
   },
};
</script>

